"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeUrl = void 0;
/**
 * Entities for text node insertion selected based on this topic https://stackoverflow.com/a/14765813
 */
const htmlEscapes = {
    // Special HTML character
    '&': '&amp;',
    // Tag opening character
    '<': '&lt;',
};
const unescapedHtmlRegExp = new RegExp(`[${Object.keys(htmlEscapes).join('')}]`, 'g');
/**
 * Create new RegExp without `g` to prevent state preserving
 */
const hasEscapedHtmlRegExp = RegExp(unescapedHtmlRegExp.source);
const escapeHtmlChar = (char) => htmlEscapes[char] || char;
/**
 * Escape entities during direct insert in HTML `script` tag
 */
const sanitizeUrl = (text) => {
    if (hasEscapedHtmlRegExp.test(text)) {
        return text.replace(unescapedHtmlRegExp, escapeHtmlChar);
    }
    return text;
};
exports.sanitizeUrl = sanitizeUrl;
//# sourceMappingURL=utils.js.map